import React from 'react';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import styled from 'styled-components';

const FavButtonWrapper = styled.div`
  color: #ffca28;
  cursor: pointer;
  text-align: center;
`;

const FavButton = props => (
  <FavButtonWrapper
    onClick={() => props.toggleTicketFavorite(props.projectId, props.ticketId)}
  >
    {props.favorited ? <Star /> : <StarBorder />}
  </FavButtonWrapper>
);

export default FavButton;
